import { render, staticRenderFns } from "./AuthenticationStep2.vue?vue&type=template&id=54474a64"
import script from "./AuthenticationStep2.vue?vue&type=script&lang=ts"
export * from "./AuthenticationStep2.vue?vue&type=script&lang=ts"
import style0 from "./AuthenticationStep2.vue?vue&type=style&index=0&id=54474a64&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports